import { marked } from 'marked';
import { getConfig, UpdateQueryString } from "#scripts/general_functions.js";
import { setContactArticle } from "#scripts/contact_functions.js";
import language from "#scripts/translation";

let config;
let pageSize;
let pageStart;
let sortOrder;
let nextPage;
let prevPage;
let queryText;
let filterText;
let scrollTimer;
let totalHits;

export const doSearch = (searchOn) => {
	config = getConfig();
	queryText = decodeURIComponent(searchOn);
	filterText = window.getUrlAttr("filter") || "";
	pageSize = config.search.pageSize || 10;
	pageStart = window.getUrlAttr("pageStart") || 0;
	sortOrder = window.getUrlAttr("sort__order") || config.search.sortOrder || "score:desc";

	nextPage = Number(pageStart) + Number(pageSize);
	prevPage = Number(pageStart) - Number(pageSize);

	// resize events.
	window.addEventListener("resize", function () {
		if (window.innerWidth < 991) {
			const metaCount = document.querySelector(".searchresult__meta__count");
			const firstCol = document.querySelector(".searchresult__meta > .row > div:first-child");
			const categories = document.querySelector(".categories");
			if (metaCount && firstCol) {
				// firstCol.appendChild(metaCount);
			}
			else if (categories) {
				categories.parentNode.insertBefore(metaCount, categories);
			}
		} else {
			const metaCount = document.querySelector(".searchresult__meta__count");
			const firstCol = document.querySelector(".searchresult__meta > .row > div:first-child");
			if (metaCount && firstCol) {
				firstCol.appendChild(metaCount);
			}
		}
	});

	// search query field key pressed
	document.addEventListener("keypress", function (e) {
		if (e.target && e.target.id === "searchheader__inputfield") {
			if (e.keyCode === 13 && e.target.value.length > 0) {
				e.preventDefault();
				parent.location = `/search/${e.target.value}`;
			}
		}
	});

	// document.addEventListener("keyup", function (e) {
	// 	if (e.target && e.target.id === "searchheader__inputfield") {
	// 		haiveAutocomplete(e.target.value);
	// 	}
	// });

	// Search button click
	document.addEventListener("click", function (e) {
		if (e.target && e.target.classList.contains("header__button__dosearch")) {
			const input = document.querySelector(".searchheader__inputfield");
			if (input) {
				parent.location = `/search/${input.value}`;
			}
		}
	});

	// Category group header Click
	document.addEventListener("click", function (e) {
		if (e.target && e.target.closest(".categories__listheader")) {
			const header = e.target.closest(".categories__listheader");
			header.classList.toggle("closed");
			const group = header.parentNode.querySelector(".categories__listgroup");
			if (group) group.style.display = group.style.display === "none" ? "" : "none";
		}
	});

	// Category click
	document.addEventListener("click", function (e) {
		if (e.target && e.target.matches(".categories__listitem input")) {
			const checkedInputs = document.querySelectorAll("input.categories__listcheck:checked");
			filterText = "";
			checkedInputs.forEach((input, idx) => {
				if (filterText.length > 0) filterText += " or ";
				filterText += `${input.getAttribute("data-category_group")}:${input.getAttribute("data-category_select")}`;
			});
			resetToFirstPage();
			tellusrFind(queryText, filterText);
		}
	});

	// click sort order dropdown
	document.addEventListener("click", function (e) {
		if (e.target && e.target.closest('.searchresult__meta__dropdown-button')) {
			// if (e.target && e.target.classList.contains("searchresult__meta__dropdown-button")) {
			const btn = e.target.closest('.searchresult__meta__dropdown-button');
			btn.classList.toggle("open");
			const menu = btn.parentNode.querySelector(".dropdown-menu");
			if (menu) menu.style.display = menu.style.display === "block" ? "none" : "block";
		}
	});

	// Click selected sort order
	document.addEventListener("click", function (e) {
		if (e.target && e.target.closest(".searchresult__meta__dropdown-content span")) {
			const span = e.target.closest("span");
			sortOrder = span.innerText === "Dato" ? "published:desc" : "score:desc";
			UpdateQueryString("sort", sortOrder);
			resetToFirstPage();
			tellusrFind(queryText, filterText);
			const btn = document.querySelector(".searchresult__meta__dropdown-button");
			const menu = document.querySelector(".searchresult__meta__dropdown .dropdown-menu");
			if (btn) btn.classList.toggle("open");
			if (menu) menu.style.display = menu.style.display === "block" ? "none" : "block";
		}
	});

	// Pagination button click
	document.addEventListener("click", function (e) {
		if (e.target && e.target.closest(".searchresult__pagination a")) {
			const a = e.target.closest("a");
			if (a.classList.contains("searchresult__prev__page")) {
				pageStart = Number(prevPage);
			} else if (a.classList.contains("searchresult__next__page")) {
				pageStart = Number(nextPage);
			}
			prevPage = Number(pageStart) - Number(pageSize);
			nextPage = Number(pageStart) + Number(pageSize);

			UpdateQueryString("pageStart", pageStart);
			tellusrFind(queryText, filterText);//, "compute/tellusrRagAlt");
			const elmnt = document.getElementById("mainCol");
			if (elmnt) elmnt.scrollIntoView();
		}
	});

	// Infinite Scroll
	if (config.search.infinityScroll) {
		document.addEventListener("scroll", (e) => {
			if (scrollTimer) {
				window.clearTimeout(scrollTimer);
			}

			scrollTimer = window.setTimeout(() => {
				const footer = document.getElementById("footer");
				const scrollTop = window.scrollY;
				const windowHeight = window.innerHeight;
				const bodyHeight = document.body.scrollHeight - windowHeight;
				const scrollPercentage = scrollTop / bodyHeight;

				// if the scroll is more than 75% from the top, load more content.
				if (scrollPercentage > 0.75) {
					if (pageStart + pageSize < totalHits) {
						pageStart = Number(nextPage);
						UpdateQueryString("pageStart", pageStart);
						tellusrFind(queryText, filterText);
					}
				}
			}, 150);
		});
	}

	// tellusrRagFind(queryText, filterText);
	tellusrFind(queryText, filterText);
	const useFilters = window.serverdata.configMeta.aim.search.useFilters ?? true;
	if (useFilters) {
		tellusrCategorize(queryText, filterText);
	}
};

export const getMetadataValue = (result, metakey) => {
	if (!result || !result.metaObject) return "";
	const metadata = JSON.parse(result.metaObject)[metakey];
	return metadata != null ? metadata : "";
};

const tellusrFind = (queryText, filter) => {
	const facets = window.serverdata.configMeta.aim?.search?.facets || {};
	const queryFilter = BuildQueryFilter(filter);
	const query = {
		q: queryText.replace(/:aimdebug/g, "").trim(),
		hl: true,
		// "semantic.hl.field": "content_segment", 
		"regular.hl.fl": "content_segment, intro",
		"regular.hl.fragsize": 150,
		semanticWeight: window.serverdata.configMeta.aim?.search?.semanticWeight ?? 0.5,
		focus: window.serverdata.configMeta.aim?.search?.focus ?? 0,
		"semantic.similarity.min": getSearchWeight(queryText.replace(/:aimdebug/g, "").trim()), //0.3,
		fq: queryFilter,
		// "regular.qf": "doc_id^500 title^1.5 intro^1.3 content_segment^1 _text_^1 tags^1.5",
		sort: sortOrder,
		pageSize: pageSize,
		pageStart: pageStart,
		facet: facets,
		...(queryText.includes(":aimdebug") && { debug: true })
	};

	const environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
	const indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`
	const searchApiUrl = `https://prokom.tellusrapp.com/api/external/proxy/tellusr/api/v1/${indexName}/query`;
	fetch(searchApiUrl, {
		method: "POST",
		body: JSON.stringify(query),
		headers: {
			"Content-Type": "application/json",
			Authorization: `Basic ${btoa("tellusr:norske kommuner 2025")}`,
		},
	})
		.then((results) => results.json())
		.then((data) => {
			totalHits = data.info["count.results.total"] ?? 0;
			DisplaySearchResult(data);

			const useFilters = window.serverdata.configMeta.aim.search.useFilters ?? true;
			if (useFilters) {
				// DisplayCategories(data);

				if (window.innerWidth < 991) {
					// Close all categories
					document.querySelectorAll(".categories__listheader").forEach(header => {
						header.classList.toggle("closed");
						const group = header.parentNode.querySelector(".categories__listgroup");
						if (group) group.style.display = group.style.display === "none" ? "" : "none";
					});
				}
			}
		});
};
const tellusrRagFind = (queryText, filter) => {
	const facets = window.serverdata.configMeta.aim?.search?.facets || {};
	const queryFilter = BuildQueryFilter(filter);
	const query = {
		q: queryText.replace(/:aimdebug/g, "").trim(),
		hl: true,
		// regular: {
		// 	hl: {
		// 		fragsize: 10
		// 	}
		// },
		"regular.hl.fragsize": 150,
		semanticWeight: window.serverdata.configMeta.aim?.search?.semanticWeight ?? 0.5,
		focus: window.serverdata.configMeta.aim?.search?.focus ?? 0,
		"semantic.similarity.min": 0.7,
		fq: queryFilter,
		// "regular.qf": "doc_id^500 title^1.5 intro^1.3 content_segment^1 _text_^1 tags^1.5",
		"regular.hl.fl": "content_segment, intro",
		sort: sortOrder,
		pageSize: 1,
		pageStart: 0,
		facet: facets,
		...(queryText.includes(":aimdebug") && { debug: true })
		// qf: "title^5 intro^0.1"
		// facet: {
		// 	contentTypeDisplayName: {
		// 		type: "value",
		// 		limit: 10,
		// 	}
		// } 
	};

	const environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
	const indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`
	const searchApiUrl = `https://prokom.tellusrapp.com/api/external/proxy/tellusr/api/v1/${indexName}//compute/tellusrRagAlt`;
	fetch(searchApiUrl, {
		method: "POST",
		body: JSON.stringify(query),
		headers: {
			"Content-Type": "application/json",
			Authorization: `Basic ${btoa("tellusr:norske kommuner 2025")}`,
		},
	})
		.then((results) => results.json())
		.then((data) => {
			totalHits = data.info["count.results.total"] ?? 0;
			DisplayRagResult(data);

			const useFilters = window.serverdata.configMeta.aim.search.useFilters ?? true;
			if (useFilters) {
				// DisplayCategories(data);

				if (window.innerWidth < 991) {
					// Close all categories
					document.querySelectorAll(".categories__listheader").forEach(header => {
						header.classList.toggle("closed");
						const group = header.parentNode.querySelector(".categories__listgroup");
						if (group) group.style.display = group.style.display === "none" ? "" : "none";
					});
				}
			}
		});
};
const tellusrCategorize = (queryText, filter) => {
	const facets = window.serverdata.configMeta.aim?.search?.facets || {};
	const queryFilter = BuildQueryFilter(filter);
	const query = {
		q: queryText.replace(/:aimdebug/g, "").trim(),
		hl: true,
		semanticWeight: window.serverdata.configMeta.aim?.search?.semanticWeight || 0.5,
		focus: window.serverdata.configMeta.aim?.search?.focus || 0,
		"semantic.similarity.min": 0.7,
		fq: queryFilter,
		// "regular.qf": "doc_id^500 title^1.5 intro^1.3 content_segment^1 xtags^1.5",
		sort: sortOrder,
		pageSize: pageSize,
		pageStart: pageStart,
		facet: facets
	};

	const environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
	const indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`
	const searchApiUrl = `https://prokom.tellusrapp.com/api/external/proxy/tellusr/api/v1/${indexName}/query`;
	fetch(searchApiUrl, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Authorization: `Basic ${btoa("tellusr:norske kommuner 2025")}`,
		},
		body: JSON.stringify(query),
	})
		.then((results) => results.json())
		.then((data) => {
			DisplayCategories(data);

			if (window.innerWidth < 991) {
				document.querySelectorAll(".categories__listheader").forEach(header => {
					header.classList.toggle("closed");
					const group = header.parentNode.querySelector(".categories__listgroup");
					if (group) group.style.display = group.style.display === "none" ? "" : "none";
				});
			}
		});
};

const tellusrAutocomplete = (queryText) => {
	fetch(window.searchEngine, {
		method: "POST",
		headers: {
			ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
			"Content-Type": "application/graphql",
		},
		body: ` query {      
                    index {     
                        autocomplete(
                            searchQuery: "${queryText}",
                            maxSuggestions: 10,
                            minQueryLength: 3
                        )
                    }
                }`,
	})
		.then(res => res.json())
		.then(data => {
			DisplayAutocomplete(data.data);
		});
};

const DisplaySearchResult = (data) => {
	let debug = window.serverdata.configMeta.aim.search.showDebugInfo || false;
	const searchInputElm = document.getElementById("searchheader__inputfield");

	// Remove loading spinner
	document.querySelectorAll(".lds-ellipsis").forEach(el => el.remove());
	if (!config.search.infinityScroll) {
		const list = document.querySelector(".searchresult__list");
		if (list) list.innerHTML = "";
	}

	if (searchInputElm)
		searchInputElm.value = queryText;

	if (config.search.useFilters) {
		const leftCol = document.getElementById("leftCol");
		const mainCol = document.getElementById("mainCol");
		if (leftCol) {
			leftCol.style.display = "block";
			leftCol.style.visibility = "visible";
			leftCol.className = "col col-md-3";
		}
		if (mainCol) mainCol.className = "col col-md-9 col-lg-7";
	} else {
		const leftCol = document.getElementById("leftCol");
		const mainCol = document.getElementById("mainCol");
		if (leftCol) leftCol.style.display = "none";
		if (mainCol) mainCol.className = "col col-md-8";
	}

	const hits = data.info["count.results.total"] ?? 0;

	// Add search result for "Min Kommune" if enabled
	if (window.serverdata.configMeta.aim?.mysite?.enabled) {
		const searchWords = (window.serverdata.configMeta.aim.search?.mysite?.searchTerms || [
			"min kommune", "min side", "minside", "mysite", "postkasse",
			"eiendommer", "eiendom", "bolig", "boliger", "boligside",
			"nasjonale tjenester", "faktura", "fakturaer"
		]).map(word => word.trim().toLowerCase());

		const inputValue = searchInputElm.value.trim().toLowerCase();

		if (searchWords.includes(inputValue)) {
			const mysiteTitle = language("NAV_MYPAGE");
			const mysiteExtract = window.serverdata.configMeta.aim.search?.mysite?.searchExtract || language("NAV_MYPAGE_DESCRIPTION");
			const mysiteItem = `
			<div class="searchresult__list__item" data-type="minside">
				<h2 class="searchresult__list__title">
					<a href="/minside" class="searchresult__list__link">${mysiteTitle}</a>
				</h2>
				<div class="searchresult__list__desc">${mysiteExtract}</div>
			</div>`;

			const list = document.querySelector(".searchresult__list");
			if (list) list.insertAdjacentHTML("beforeend", mysiteItem);
		}
	}

	data.results.forEach((result, snumber) => {
		let itemLayout = "";

		if (searchInputElm.value.includes(":aimdebug")) {
			debug = true;
		}
		if (result.id === null) {
			const list = document.querySelector(".searchresult__list");
			if (list) list.insertAdjacentHTML("beforeend", formatDebugItem(result));
		} else {
			let linkUrl = "";
			const linkItem = result.nameInUrl?.trim() || result.shortName?.trim() || result.contentId;

			const prefixMap = {
				Blokk: "blokk", // skal ikke finnes i indeksen
				Nyhet: "nyhet"
			};
			const prefix = prefixMap[result.contentTypeDisplayName] || "artikkel";
			linkUrl = `/${prefix}/${linkItem}`;

			// if (result.pageTypeId === "mal_blokk") {
			// 	linkUrl = `/blokk/${linkItem}`;
			// } else {
			// 	linkUrl = `/artikkel/${linkItem}`;
			// }

			let debugExtract = '';
			if (debug) {
				const environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
				const indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`

				debugExtract = `Total score: ${result["score"]?.toFixed(2)} [Regular: ${result["score.regular"]?.toFixed(2) || '0'} - Symantisk: ${result["score.semantic"]?.toFixed(2) || '0'}]<br/> 
				PageTemplate: ${result.contentTypeDisplayName}<br/>
				Index: ${indexName}`;
			}

			const date = new Date(result.published);
			// const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
			let pDate = date instanceof Date && !isNaN(date) ? `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}` : '';


			if (!result.contentTypeDisplayName) return; // skip 

			let pageType = result.contentTypeDisplayName.toLowerCase();
			pageType = pageType === "" ? "file" : pageType;
			const filePath = result?.href;

			let matchType;
			const regularScore = result["score.regular"] || 0;
			const semanticScore = result["score.semantic"] || 0;
			if (regularScore > semanticScore) {
				matchType = "regular";
			} else if (semanticScore > regularScore) {
				matchType = "semantic";
			} else {
				matchType = "semantic"
				matchType = window.serverdata.configMeta.aim.search?.prioritizeSemanticHighlight ? "semantic" : "regular";
			}

			const queryArray = searchInputElm.value.replace(/:aimdebug/g, "").trim().split(/\s+/);
			// Escape regex characters in each word
			const escapedWords = queryArray
				.filter(Boolean)
				.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

			// Create a single regex from all words
			const highlightRegex = new RegExp(`(^|\\s|[.,;!?()'"-])(${escapedWords.join("|")})(?=\\s|[.,;!?()'"-]|$)`, "gi");

			let extract = "";
			if (result?.highlights?.length === 1) {
				extract = result?.highlights[0].highlight;
			} else if (result?.highlights?.length > 1) {
				const found = result?.highlights.find(item => item.matchType === matchType);
				extract = found ? found.highlight : "";
			}
			else if (result?.highlights?.length <= 0 && window.serverdata.configMeta.aim.search?.showIntroAsExtract) {
				let found = result?.intro;
				if (found && found.trim() !== "") {
					found = found.replace(highlightRegex, '$1<em>$2</em>');
					extract = found;
				}
			}

			// extract = extract.replace(/(#+) (.*?)(\n|$)/g, " $2"); //.replace(/\n/g, " ");
			extract = extract.replace(/^(#+) ([^\n\r]*)/gm, " $2");
			extract = extract.replace(/Kontaktkort:/g, " Kontaktkort:");

			if (window.serverdata.configMeta.aim.search?.useMarkdownExtract && extract) {
				extract = marked.parse(extract);
			}

			const rawTitle = result.title || "";

			// Replace matches with <em> tag
			const title = rawTitle.replace(highlightRegex, '$1<em>$2</em>');

			switch (pageType) {
				case "enhet":
					itemLayout = `
								<div data-nr='${snumber}' class="searchresult__list__item" data-type="enhet">
										<div class="searchresult__list__mal_enhetsmal">
												<h2 class="searchresult__list__title">
														<a href="${linkUrl}" class="searchresult__list__link">${title}</a>
												</h2>
												<div class="searchresult__list__desc">${extract}</div>
												<p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
												<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
										</div>
								</div>`;
					break;
				case "kontaktkort": {
					const contact = setContactArticle({
						name: result.title || "",
						email: getMetadataValue(result, "personEpost") || "",
						title: getMetadataValue(result, "personStilling") || "",
						phone: getMetadataValue(result, "personMobil") || "",
						wiredPhone: getMetadataValue(result, "personTelefon") || "",
						about: getMetadataValue(result, "personFritekst") || "",
						department: getMetadataValue(result, "personAvdeling") || "",
						image: result.thumbnail || getMetadataValue(result, "imageContentId") || ""
					});

					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item" data-type="kontakt">
									<div class="searchresult__list__mal_visittkort">
										${contact}
										<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
									</div>
                </div>`;
					break;
				}
				case "file":
				case "dokument":
					if (!pDate) {
						const date = new Date(result.date);
						pDate = date instanceof Date && !isNaN(date) ? `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}` : '';
					}
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${filePath}" class="searchresult__list__link" target="_blank" rel="noopener" download>${title}</a>
                  </h2>
                  <div class="searchresult__list__desc">${extract}</div>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
									<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
                </div>`;
					break;
				case "nyhet":
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item" data-type="nyhet">
									<div class="searchresult__list__mal_nyhetsmal">
										<h2 class="searchresult__list__title">
												<a href="${linkUrl}" class="searchresult__list__link">${title}</a>
										</h2>
                    <div class="searchresult__list__desc">${extract}</div>
										<p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
										<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
									</div>
                </div>`;
					break;
				default:
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${linkUrl}" class="searchresult__list__link">${title}</a>
                  </h2>
                  <div class="searchresult__list__desc">${extract}</div>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
									<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
                </div>`;
			}
			const list = document.querySelector(".searchresult__list");
			if (list) list.insertAdjacentHTML("beforeend", itemLayout);
		}
	});

	if (window.innerWidth < 768) {
		const destination = document.querySelector(".categories");
		const metaCount = document.querySelector(".searchresult__meta__count");
		if (metaCount && destination) {
			destination.parentNode.insertBefore(metaCount, destination);
		}
	}

	const metaCount = document.querySelector(".searchresult__meta__count");
	if (metaCount) metaCount.innerHTML = `${language("SEARCH_NUMHITS")}: ${hits}`;

	const dropdownContent = document.querySelector(".searchresult__meta__dropdown-content");
	if (dropdownContent) {
		dropdownContent.innerHTML = `<li><span>${language("SEARCH_RELEVANCE")}</span></li><li><span>${language("SEARCH_DATE")}</span></li>`;
	}

	if (!config.search.infinityScroll) {
		if (pageSize > hits) {
			pageSize = hits;
		}
		const pagination = document.querySelector(".searchresult__pagination");
		if (pagination) {
			pagination.innerHTML = `
                <a class="searchresult__prev__page ${pageStart !== 0 ? "" : 'disabled" aria-disabled="true'}" role="button">❮</a>
                <a class="searchresult__next__page ${hits > nextPage ? "" : 'disabled" aria-disabled="true'}" role="button">❯</a>
                <div>${Number(pageStart) + 1}-${Number(pageStart) + Number(pageSize)} ${language("SEARCH_OF")} ${hits}</div>`;
		}
	}

	if (hits === 0) {
		const meta = document.querySelector(".searchresult__meta");
		if (meta) {
			meta.innerHTML = `
                    <div class="searchresult__count">${language("SEARCH_TOTALHITS")}: 0</div>
                    <div class="searchresult__showcount">${language("SEARCH_NOHITS_DESC")}</div>
                `;
		}
		const pagination = document.querySelector(".searchresult__pagination");
		if (pagination) pagination.innerHTML = "";
	}

	const currentPageBreadcrumb = document.getElementById("currentPageBreadcrumb");
	if (currentPageBreadcrumb) currentPageBreadcrumb.textContent = document.title;

	const headerInput = document.querySelector(".header__search__input");
	if (headerInput) headerInput.value = queryText;

	const choosedTxt = document.querySelector(".searchresult__meta__choosedtxt");
	if (choosedTxt) choosedTxt.innerHTML = `${sortOrder === "published:desc" ? language("SEARCH_DATE") : language("SEARCH_RELEVANCE")}`;

	// // toggleIcon.addEventListener("click", () => {
	// document.addEventListener("click", function (e) {
	// 	if (e.target && e.target.id === 'toggleIcon') {
	// 		isExpanded = !isExpanded;
	// 		updateText();
	// 	}
	// });

	document.querySelectorAll('.searchresult__list__desc').forEach(block => {
		const fullDiv = document.createElement('span');
		fullDiv.innerHTML = block.innerHTML;
		fullDiv.style.display = '-webkit-box';
		fullDiv.style.webkitBoxOrient = 'vertical';
		fullDiv.style.overflow = 'hidden';
		fullDiv.style.textOverflow = 'ellipsis';
		fullDiv.style.lineClamp = '4';
		fullDiv.style.webkitLineClamp = '4';
		fullDiv.style.lineHeight = '24px';

		// Replace original block
		block.innerHTML = '';
		block.appendChild(fullDiv);

		if (fullDiv.scrollHeight <= (4 * 24)) return; /* height of 4 lines with lineheight = 24px */

		// Create toggle
		const toggleBtn = document.createElement('span');
		toggleBtn.classList.add('searchresult__list__desc__toggle');
		toggleBtn.textContent = 'Vis mer';
		// toggleBtn.style.cursor = 'pointer';
		// toggleBtn.style.borderRadius = '100rem';
		// toggleBtn.style.backgroundColor = 'rgb(0 0 0 / .07)';
		// toggleBtn.style.paddingInline = '15px';
		// toggleBtn.style.verticalAlign = 'middle';
		// toggleBtn.style.display = 'inline-flex';
		// toggleBtn.style.fontSize = '0.875rem';
		// toggleBtn.style.maxHeight = '1.37rem';
		// toggleBtn.style.top = '-1px';
		// toggleBtn.style.position = 'relative';

		const toggleBtnIcon = document.createElement('span');
		toggleBtnIcon.classList.add('material-icons-outlined')
		toggleBtnIcon.textContent = 'expand_more';
		// toggleBtnIcon.style.fontFamily = 'Material Icons Outlined';
		// toggleBtnIcon.style.position = 'relative';
		// toggleBtnIcon.style.fontSize = '1.375rem';
		// toggleBtnIcon.style.paddingLeft = '3px';
		toggleBtn.appendChild(toggleBtnIcon);

		toggleBtn.addEventListener('click', () => {
			const isExpanded = fullDiv.style.lineClamp === 'unset';
			fullDiv.style.lineClamp = isExpanded ? '4' : 'unset';
			fullDiv.style.webkitLineClamp = isExpanded ? '4' : 'unset';
			toggleBtn.textContent = isExpanded ? 'Vis mer' : 'Vis mindre';
			toggleBtnIcon.textContent = isExpanded ? 'expand_more' : 'expand_less';
			toggleBtn.appendChild(toggleBtnIcon); // Re-append icon to ensure it stays at the end
		});

		block.appendChild(toggleBtn);
	});
};

const DisplayRagResult = (data) => {
	let debug = window.serverdata.configMeta.aim.search.showDebugInfo || false;
	const searchInputElm = document.getElementById("searchheader__inputfield");

	// Remove loading spinner
	document.querySelectorAll(".lds-ellipsis").forEach(el => el.remove());
	if (!config.search.infinityScroll) {
		const list = document.querySelector(".searchresult__list");
		if (list) list.innerHTML = "";
	}

	if (searchInputElm)
		searchInputElm.value = queryText;

	if (config.search.useFilters) {
		const leftCol = document.getElementById("leftCol");
		const mainCol = document.getElementById("mainCol");
		if (leftCol) {
			leftCol.style.display = "block";
			leftCol.style.visibility = "visible";
			leftCol.className = "col col-md-3";
		}
		if (mainCol) mainCol.className = "col col-md-9 col-lg-7";
	} else {
		const leftCol = document.getElementById("leftCol");
		const mainCol = document.getElementById("mainCol");
		if (leftCol) leftCol.style.display = "none";
		if (mainCol) mainCol.className = "col col-md-8";
	}

	const hits = data.info["count.results.total"] ?? 0;

	data.results.forEach((result, snumber) => {
		let itemLayout = "";

		if (searchInputElm.value.includes(":aimdebug")) {
			debug = true;
		}
		if (result.id === null) {
			const list = document.querySelector(".searchresult__list");
			if (list) list.insertAdjacentHTML("beforeend", formatDebugItem(result));
		} else {
			let linkUrl = "";
			const linkItem = result.nameInUrl?.trim() || result.shortName?.trim() || result.contentId;


			const prefixMap = {
				Blokk: "blokk", // skal ikke finnes i indeksen
				Nyhet: "nyhet"
			};
			const prefix = prefixMap[result.contentTypeDisplayName] || "artikkel";
			linkUrl = `/${prefix}/${linkItem}`;

			let debugExtract = '';
			if (debug) {
				const environment = window.AimCookies.RuntimeMode === "dev" ? 'development' : (window.AimCookies.RuntimeMode === undefined || window.AimCookies.RuntimeMode === "" || window.AimCookies.RuntimeMode === "prod") ? 'production' : window.AimCookies.RuntimeMode;
				const indexName = `aim-site-${window.serverdata.configMeta.aim.search.dedicatedIndex ? window.serverdata.configMeta.aim.nameId : 'shared'}-${environment}`

				debugExtract = `Total score: ${result["score"]?.toFixed(2)} [Regular: ${result["score.regular"]?.toFixed(2) || '0'} - Symantisk: ${result["score.semantic"]?.toFixed(2) || '0'}]<br/> 
				PageTemplate: ${result.contentTypeDisplayName}<br/>
				Index: ${indexName}`;
			}

			const date = new Date(result.published);
			const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;
			let pageType = result.contentTypeDisplayName.toLowerCase();
			pageType = pageType === "" ? "file" : pageType;
			const filePath = result?.href;

			const matchType =
				(result["score.regular"] || 0) >= (result["score.semantic"] || 0) ? "regular" : "semantic";

			const queryArray = searchInputElm.value.replace(/:aimdebug/g, "").trim().split(/\s+/);
			// Escape regex characters in each word
			const escapedWords = queryArray
				.filter(Boolean)
				.map(word => word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));

			// Create a single regex from all words
			const highlightRegex = new RegExp(`(^|\\s|[.,;!?()'"-])(${escapedWords.join("|")})(?=\\s|[.,;!?()'"-]|$)`, "gi");

			let extract = "";
			if (result?.highlights?.length === 1) {
				extract = result?.highlights[0].highlight;
			} else if (result?.highlights?.length > 1) {
				const found = result?.highlights.find(item => item.matchType === matchType);
				extract = found ? found.highlight : "";
			}
			else if (result?.highlights?.length <= 0 && window.serverdata.configMeta.aim.search?.showIntroAsExtract) {
				let found = result?.intro;
				if (found && found.trim() !== "") {
					found = found.replace(highlightRegex, '$1<em>$2</em>');
					extract = found;
				}
			}

			// extract = extract.replace(/(#+) (.*?)(\n|$)/g, " $2"); //.replace(/\n/g, " ");
			extract = extract.replace(/^(#+) ([^\n\r]*)/gm, " $2");
			extract = extract.replace(/Kontaktkort:/g, " Kontaktkort:");

			if (window.serverdata.configMeta.aim.search?.useMarkdownExtract && extract) {
				extract = marked.parse(extract);
			}

			const rawTitle = result.title || "";

			// Replace matches with <em> tag
			const title = rawTitle.replace(highlightRegex, '$1<em>$2</em>');

			switch (pageType) {
				case "enhet":
					itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item" data-type="enhet">
                            <div class="searchresult__list__mal_enhetsmal">
                                <h2 class="searchresult__list__title">
                                    <a href="${linkUrl}" class="searchresult__list__link">${result.title}</a>
                                </h2>
                                <p class="searchresult__list__desc">${extract}</p>
                                <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
																<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
                            </div>
                        </div>`;
					break;
				case "kontaktkort": {
					const contact = setContactArticle({
						name: result.title || "",
						email: getMetadataValue(result, "personEpost") || "",
						title: getMetadataValue(result, "personStilling") || "",
						phone: getMetadataValue(result, "personMobil") || "",
						wiredPhone: getMetadataValue(result, "personTelefon") || "",
						about: getMetadataValue(result, "personFritekst") || "",
						department: getMetadataValue(result, "personAvdeling") || "",
					});

					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item" data-type="kontakt">
									<div class="searchresult__list__mal_visittkort">
										${contact}
										<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
									</div>
                </div>`;
					break;
				}
				case "file":
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${filePath}" class="searchresult__list__link">${result.title}</a>
                  </h2>
                  <p class="searchresult__list__desc">${extract != null ? extract : ""}</p>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
									<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
                </div>`;
					break;
				case "nyhet":
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item" data-type="nyhet">
									<div class="searchresult__list__mal_nyhetsmal">
										<h2 class="searchresult__list__title">
												<a href="${linkUrl}" class="searchresult__list__link">${result.title}</a>
										</h2>
										<p class="searchresult__list__desc">${extract}</p>
										<p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
										<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
									</div>
                </div>`;
					break;
				default:
					itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${linkUrl}" class="searchresult__list__link">${result.title}</a>
                  </h2>
                  <p class="searchresult__list__desc">${extract}</p>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
									<p class="searchresult__list__debug ${debug ? '' : ' d-none'}">${debugExtract}</p>
                </div>`;
			}
			const list = document.querySelector(".searchresult__list");
			if (list) list.insertAdjacentHTML("beforeend", itemLayout);
		}
	});

	if (window.innerWidth < 768) {
		const destination = document.querySelector(".categories");
		const metaCount = document.querySelector(".searchresult__meta__count");
		if (metaCount && destination) {
			destination.parentNode.insertBefore(metaCount, destination);
		}
	}

	const metaCount = document.querySelector(".searchresult__meta__count");
	if (metaCount) metaCount.innerHTML = `${language("SEARCH_NUMHITS")}: ${hits}`;

	const dropdownContent = document.querySelector(".searchresult__meta__dropdown-content");
	if (dropdownContent) {
		dropdownContent.innerHTML = `<li><span>${language("SEARCH_RELEVANCE")}</span></li><li><span>${language("SEARCH_DATE")}</span></li>`;
	}

	if (!config.search.infinityScroll) {
		if (pageSize > hits) {
			pageSize = hits;
		}
		const pagination = document.querySelector(".searchresult__pagination");
		if (pagination) {
			pagination.innerHTML = `
                <a class="searchresult__prev__page ${pageStart !== 0 ? "" : 'disabled" aria-disabled="true'}" role="button">❮</a>
                <a class="searchresult__next__page ${hits > nextPage ? "" : 'disabled" aria-disabled="true'}" role="button">❯</a>
                <div>${Number(pageStart) + 1}-${Number(pageStart) + Number(pageSize)} ${language("SEARCH_OF")} ${hits}</div>`;
		}
	}

	if (hits === 0) {
		const meta = document.querySelector(".searchresult__meta");
		if (meta) {
			meta.innerHTML = `
                    <div class="searchresult__count">${language("SEARCH_TOTALHITS")}: 0</div>
                    <div class="searchresult__showcount">${language("SEARCH_NOHITS_DESC")}</div>
                `;
		}
		const pagination = document.querySelector(".searchresult__pagination");
		if (pagination) pagination.innerHTML = "";
	}

	const currentPageBreadcrumb = document.getElementById("currentPageBreadcrumb");
	if (currentPageBreadcrumb) currentPageBreadcrumb.textContent = document.title;

	const headerInput = document.querySelector(".header__search__input");
	if (headerInput) headerInput.value = queryText;

	const choosedTxt = document.querySelector(".searchresult__meta__choosedtxt");
	if (choosedTxt) choosedTxt.innerHTML = `${sortOrder === "published:desc" ? language("SEARCH_DATE") : language("SEARCH_RELEVANCE")}`;
};
const DisplayCategories = (_data) => {
	const data = _data.info;
	let currentGroup = "";
	const categoriesCollection = document.querySelector(".categories__collection");
	if (!categoriesCollection) return;

	// Clear previous categories
	categoriesCollection.innerHTML = "";

	Object.entries(data.facets).forEach(([key, result]) => {
		const hiddenGroups = ["contentsubscribers", "subscriptionid", "language", "categories"];
		if (!hiddenGroups.includes(key.toLowerCase())) {
			const translatedGroupName = language(`SEARCH_${key?.toUpperCase()}`);
			if (currentGroup !== key) {
				const catHead = document.createElement("div");
				catHead.className = "categories__group";
				catHead.innerHTML = `
                    <div class="categories__listheader">
                        <div class="categories__listheaderlink">
                          <span>${!translatedGroupName.startsWith("SEARCH_") ? translatedGroupName : key}</span>
                          <span class="icon material-icons-outlined notranslate">&#xe5ce</span>
                        </div>
                    </div>
                    <ul class="categories__listgroup list-group" data-category_group="${key}" ></ul>`;
				categoriesCollection.appendChild(catHead);
			}
			currentGroup = key;
			const filter = window.getUrlAttr("filter");
			let isSelected = false;
			if (filter != null) {
				isSelected = window.getUrlAttr("filter").includes(result.path.join("|"));
			}
			if (result.items.length > 0) {
				const listGroup = categoriesCollection.querySelector(`.categories__listgroup[data-category_group='${currentGroup}']`);
				result.items.forEach((resultItem) => {
					const translatedCategoryName = language(`SEARCH_CAT_${resultItem.value?.toUpperCase()}`);
					const groupItem = document.createElement("li");
					groupItem.className = "list-group-item justify-content-between categories__listitem";
					groupItem.innerHTML = `
                      <div class="categories__listitem__checkbox">
                        <label>
                          <input type="checkbox" class="categories__listcheck" ${isSelected ? "checked" : ""} data-category_group="${currentGroup}" data-category_select="${resultItem.value}"/><span class="checkmark"></span>${!translatedCategoryName.startsWith("SEARCH_CAT_") ? translatedCategoryName : resultItem.value} (${resultItem.count})
                        </label>
                      </div>
                  `;
					if (listGroup) listGroup.appendChild(groupItem);
				});
			}
		}
	});
};

const formatDebugItem = (item) => {
	return `
        <h2>${item.title}</h2>${item.extracts.split("<b>").join("<br/><b>")}<br/><br/>`;
};
const formatStatsItem = (item) => {
	const regexp =
		/version:\s*(?<ver>[^<]*)<.*?Total no of items:\s*(?<items>[^<]*)<.*?Active items:\s*(?<active>[^<]*)<.*?Deleted items:\s*(?<deleted>[^<]*)<.*?Last item id:\s*(?<lastid>[^<]*)<.*?Last item date:\s*(?<lastitemdate>[^<]*)<.*?Memory working set:\s*(?<memworking>[^<]*)<.*?Free memory:\s*(?<memfree>[^<]*)<.*?Threads in use:\s*(?<threads>[^<]*)<.*?Index diskspace usage:\s*(?<diskusage>[^<]*)<.*?Free space on index drive:\s*(?<diskfree>[^<]*)<.*?Physical processors:\s*(?<processors>[^<]*)<.*?Physical cores:\s*(?<cores>[^<]*)<.*?Logical cores:\s*(?<coreslogical>[^<]*)<.*?OS version:\s*(?<osver>[^<]*)<.*?64bit OS:\s*(?<os64bit>[^<]*)<.*?\d{2}bit process:\s*(?<proc64bit>[^<]*)<.*?\.NET version:\s*(?<netver>[^<]*)<.*?Current directory:\s*(?<dir>[^<]*)<.*?Machine name:\s*(?<machine>[^<]*)<.*?User:\s*(?<user>[^<]*) \[Interactive:\s*(?<interactive>[^<]*)\]/i;

	const matchObj = regexp.exec(item);

	return `
    <h2>Index statistics</h2>
    <table>
        <tr><th>Product version:</th><td>${matchObj[1]}</td></tr>
        <tr><th>Total items:</th><td>${matchObj[2]}</td></tr>
        
        <tr><th>Active items:</th><td>${matchObj[3]}</td></tr>
        <tr><th>Deleted items:</th><td>${matchObj[4]}</td></tr>
        <tr><th>Last item id:</th><td>${matchObj[5]}</td></tr>
        <tr><th>Last item date:</th><td>${matchObj[6]}</td></tr>
        <tr><th>Memory working set:</th><td>${matchObj[7]}</td></tr>
        <tr><th>Free memory:</th><td>${matchObj[8]}</td></tr>
        <tr><th>Threads in use:</th><td>${matchObj[9]}</td></tr>
        <tr><th>Index diskspace usage:</th><td>${matchObj[10]}</td></tr>
        <tr><th>Free space on index drive:</th><td>${matchObj[11]}</td></tr>
        <tr><th>Physical processors:</th><td>${matchObj[12]}</td></tr>
        <tr><th>Physical cores:</th><td>${matchObj[13]}</td></tr>
        <tr><th>Logical cores:</th><td>${matchObj[14]}</td></tr>
        <tr><th>OS version:</th><td>${matchObj[15]}</td></tr>
        <tr><th>64bit OS:</th><td>${matchObj[16]}</td></tr>
        <tr><th>64bit process:</th><td>${matchObj[17]}</td></tr>
        <tr><th>.NET version:</th><td>${matchObj[18]}</td></tr>
        <tr><th>Current directory:</th><td>${matchObj[19]}</td></tr>
        <tr><th>Machine name:</th><td>${matchObj[20]}</td></tr>
        <tr><th>User:</th><td>${matchObj[21]}</td></tr>
        <tr><th>Interactive:</th><td>${matchObj[22]}</td></tr>
    </table><br/>
    `;
};
const BuildQueryFilter = (filter) => {
	let queryFilter = `*:* AND (clientKey:("${window.serverdata.configMeta.aim.nameId}")`;

	if (window.serverdata.configMeta.aim.lang === undefined) {
		window.serverdata.configMeta.aim.lang = "nb";
	}
	const searchLang = localStorage.getItem("currentLanguage") || `${window.serverdata.configMeta.aim.lang}_no`;
	if (window.serverdata.configMeta.aim?.search?.filterOnLanguage !== false) {
		queryFilter += ` AND language: ("${searchLang}")`;
	}
	if (window.serverdata.configMeta.aim?.search?.includeFiles === true) {
		queryFilter += ` AND isMedia:(true OR false)`;
	} else {
		queryFilter += ` AND isMedia:(false)`;
	}

	if (filter != null) {
		filter.split(";").forEach((filterPart, index) => {
			if (filterPart !== "") {
				queryFilter += ` AND ${filterPart.split(/[|:]/)[0]}: ("${filterPart.split(/[|:]/)[1]}")`;
				// queryFilter += ` AND ${filterPart})`;
			}
		});
	}
	queryFilter += `)`;
	return queryFilter;
};
const resetToFirstPage = () => {
	pageStart = 0;
	prevPage = Number(pageStart) - Number(pageSize);
	nextPage = Number(pageStart) + Number(pageSize);
	const list = document.querySelector(".searchresult__list");
	if (list) list.innerHTML = "";
	UpdateQueryString("pageStart", pageStart);
};

function getSearchWeight (query) {
	const wordCount = query.trim().split(/\s+/).length;
	const clampedCount = Math.min(Math.max(wordCount, 1), 5); // clamp between 1 and 5
	// return 0.4 + ((clampedCount - 1) * (0.7 - 0.4)) / (5 - 1);
	return 0.78 - ((clampedCount - 1) * (0.78 - 0.4)) / (5 - 1);
}
class SearchResults {
	constructor(hits = 0, items = []) {
		this.hits = hits;
		this.items = items.map((item) => new SearchResultItem(item));
	}

	addItem (item) {
		this.items.push(new SearchResultItem(item));
		this.hits = this.items.length;
	}
}

class SearchResultItem {
	constructor({ id, title, published, publishedBy, content, url, relevance, extracts }) {
		this.id = id;
		this.title = title || "";
		this.date = published | new Date().toISOString();
		this.published = published | new Date().toISOString();
		this.publishedBy = publishedBy | "";
		this.content = content || "";
		this.url = url || "";
		this.relevance = relevance || 0.0;
		this.extracts = extracts || "";
	}
}
